<script>
    import { listings } from './listings.js';
    import Carousel from 'svelte-carousel';
    import Fa from 'svelte-fa';
    import { faMapMarkerAlt, faChartLine, faTag, faDollarSign } from '@fortawesome/free-solid-svg-icons';
    import { formatFinancialNumber } from './formatFinancialNumber.js';
    import ListingPopup from './ListingPopup.svelte';

    let selectedListing = null;

    function showListingPopup(listing) {
        selectedListing = listing;
    }

    function closeListingPopup() {
        selectedListing = null;
    }
</script>
<h2 class="text-4xl text-center mb-8">Our Featured Listings</h2>
<div class="max-w-7xl w-full overflow-hidden text-base h-[480px] no-bootstrap">
    <div class="w-full absolute overflow-hidden flex justify-center">
        <div class="w-[250vw] max-w-7xl">
            <Carousel 
                autoplay={true} 
                autoplayDuration={5000}
                particlesToShow={3}
                particlesToScroll={1}
            >
                {#each listings.filter(listing => listing.featured) as listing}
                    <div class="px-2 md:px-3 pb-4 my-auto h-full w-[80vw]">
                        <div class="bg-white rounded-lg overflow-hidden shadow-md max-w-sm h-full flex flex-col mx-auto select-none w-full max-w-[80vw]">
                            <div class="relative">
                                <img src={listing.image} alt={listing.name} class="w-full !h-48 object-cover pointer-events-none">
                                <h3 class="absolute bottom-0 left-0 right-0 text-xl font-bold p-2 text-white shadow-md bg-black bg-opacity-50">{listing.name}</h3>
                                <div class="absolute top-0 right-0 bg-amber-400 text-black font-bold px-3 py-1 m-2 rounded-full shadow-md">
                                    {formatFinancialNumber(listing.price, listing.currency)}
                                </div>
                            </div>
                            <div class="py-4 px-4 flex flex-col h-full">
                                <div class="mb-2 text-sm">
                                    <p class="text-gray-600 flex items-center">
                                        <Fa icon={faMapMarkerAlt} class="mr-2 w-4 h-4" />
                                        <span><strong>Location:</strong> {listing.location}</span>
                                    </p>
                                    <p class="text-gray-600 flex items-center">
                                        <Fa icon={faDollarSign} class="mr-2 w-4 h-4" />
                                        <span><strong>Revenue:</strong> {formatFinancialNumber(listing.revenue, listing.currency)}</span>
                                    </p>
                                    <p class="text-gray-600 flex items-center">
                                        <Fa icon={faChartLine} class="mr-2 w-4 h-4" />
                                        <span><strong>EBITDA:</strong> {formatFinancialNumber(listing.ebitda, listing.currency)}</span>
                                    </p>
                                </div>
                                <div class="pb-2 md:pb-4">
                                    <p class="text-gray-900 mb-4 description">{listing.description}</p>
                                </div>
                                <button on:click={() => showListingPopup(listing)} class="bg-amber-400 text-black font-semibold py-2 px-4 rounded block text-center">View More</button>
                            </div>
                        </div>
                    </div>
                {/each}
            </Carousel>
        </div>
    </div>
</div>

{#if selectedListing}
    <ListingPopup listing={selectedListing} on:close={closeListingPopup} />
{/if}

<style lang="postcss">
    .description {
        display: -webkit-box;
        -webkit-line-clamp: 4;
        -webkit-box-orient: vertical;
        overflow: hidden;
        text-overflow: ellipsis;
        min-height: 5.6em; /* Approximately 4 lines of text */
    }
    :global(.sc-carousel-dot__dot_active) {
        background-color: #fbbf24 !important;
    }
    p{
        margin-bottom: 0rem;
    }
</style>

